import { makeVar } from '@apollo/client';

interface NotificationLastSeen {
  timestamp: string;
}

const NOTIFICATION_LAST_SEEN_KEY = 'NOTIFICATION_LAST_SEEN';

const initialNotificationLastSeenMapVar =
  JSON.parse(window.localStorage.getItem(NOTIFICATION_LAST_SEEN_KEY) ?? '{}') ||
  {};

export const notificationLastSeenMapVar = makeVar<
  Record<string, NotificationLastSeen>
>(initialNotificationLastSeenMapVar);

export const updateNotificationLastSeen = (userId: string) => {
  const current = notificationLastSeenMapVar();
  const updated = {
    ...current,
    [userId]: {
      timestamp: new Date().toISOString(),
    },
  };

  window.localStorage.setItem(
    NOTIFICATION_LAST_SEEN_KEY,
    JSON.stringify(updated)
  );

  notificationLastSeenMapVar(updated);
};
